import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0180c225"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Detalle Partida", -1))
const _hoisted_2 = { class: "player-container" }
const _hoisted_3 = { class: "player-details" }
const _hoisted_4 = { class: "player-info" }
const _hoisted_5 = { class: "player-info" }
const _hoisted_6 = { class: "player-info" }
const _hoisted_7 = { class: "player-details" }
const _hoisted_8 = { class: "player-info" }
const _hoisted_9 = { class: "player-info" }
const _hoisted_10 = { class: "player-info" }

import {
  ViewPartidaAmistosaDTO,
  ViewPartidaTorneoDTO,
} from "@/interfaces/Partidas";
import { formatFechaSpa } from "@/utils/Fecha";
import { ref, watch, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalDetallePartida',
  props: {
    partida: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const show = ref(true);
const formattedFecha = ref<string | null>(null);

const close = () => {
  show.value = false;
  emit("close");
};

watch(show, (newValue) => {
  if (!newValue) {
    emit("close");
  }
});

onMounted(async () => {
  if (props.partida?.fechaPartida) {
    formattedFecha.value = await formatFechaSpa(props.partida.fechaPartida);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    "max-width": "800px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "modal-title" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                onClick: close,
                class: "close-button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.partida?.nickUsuario1), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.partida?.resultadoUsuario1 ?? "No especificado"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-shield-outline")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.partida?.ejercitoUsuario1 ?? "No especificado"), 1)
                  ])
                ]),
                _createVNode(_component_v_divider, {
                  vertical: "",
                  class: "divider"
                }),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.partida?.nickUsuario2), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.partida?.resultadoUsuario2 ?? "No especificado"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-shield-outline")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.partida?.ejercitoUsuario2 ?? "No especificado"), 1)
                  ])
                ])
              ]),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_list, { class: "centered-list" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-trophy")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.partida?.ganadorPartidaNick ?? "Empate"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-calendar")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(formattedFecha.value), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-map-marker")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.partida?.escenarioPartida ?? "N/A"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-cash-multiple")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.partida?.puntosPartida ?? "No especificado"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})